<template>
  <div class="d-flex p-3 selection-bar">
    <div class="mr-3">
      Selected {{ selectedIds.length }} items
    </div>
    <div class="ml-auto">
      <b-button variant="primary" @click="sendForCreate" class="mr-3">
        {{ $dt('selected_detections_bar.create_samples', 'Create Samples') }}
        </b-button>
      <b-button variant="warning" @click="clear" class="mr-3">
        {{ $dt('selected_detections_bar.clear_selection', 'Clear Selection') }}
      </b-button>
      <b-button variant="danger" @click="confirmDelete">
        {{ $dt('selected_detections_bar.delete_selected', 'Delete Selected') }}
      </b-button>
    </div>
  </div>
</template>
<script>
import Services from '@/services/index';

export default {
  name: 'SelectedDetectionsActions',
  props: {
    selectedIds: {
      value: Array,
      required: true,
    },
  },
  methods: {
    clearAll() {
      this.$emit('clearAll');
    },
    confirmDelete() {
      // ask for confirmation
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete the selected items?', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then((value) => {
          if (value) {
            this.sendForDelete();
          }
        })
        .catch((err) => {
          // An error occurred
          console.error(err);
        });
    },
    sendForDelete() {
      this.$emit('delete', this.selectedIds);
    },
    sendForCreate() {
      this.$emit('create', this.selectedIds);
    },
    clear() {
      this.$emit('clear', this.detection_ids);
    },
  }
};
</script>
<style lang="scss">
.selection-bar {
  position: -webkit-sticky;
  /* Safari */
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 1000;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.1);
  align-items: center;
}

.sidebar-lg-show.sidebar-fixed .main {
  .selection-bar {
    @media (min-width: 992px) {
      left: 200px;
    }
  }
}
</style>
